import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import {
  getNavigationMenu,
  roleBasedNavigationMenu,
} from "../store/navigationMenu/action";
import { useDispatch, useSelector } from "react-redux";
import { isEmpty } from "lodash";
import { useBranding } from "../Components/branding/Branding";
import {
  isSystemModuleActive,
  SYSTEM_MODULE_CODES,
} from "../helpers/functions/systemModules";

const Navdata = () => {
  const { isBrandingActive } = useBranding();
  // Customer Vehicle Management module gate (hides the customer Vehicle List nav item).
  const showCustomerVehicle = isSystemModuleActive(
    SYSTEM_MODULE_CODES.CUSTOMER_VEHICLE
  );
  // Task 24759 - hides the whole Events & Pre-Order group when the food module
  // is off. One module covers reservations and pre-orders alike.
  const showFoodReservation = isSystemModuleActive(
    SYSTEM_MODULE_CODES.FOOD_RESERVATION
  );
  // Change #100326 - the WhatsApp inbox has its own entry (it used to be hidden inside
  // Events & Pre-Order, so only food-module companies could find it).
  const showWhatsApp = isSystemModuleActive(SYSTEM_MODULE_CODES.WHATSAPP);
  const LSRole = JSON.parse(localStorage.getItem("authUser"))?.data?.first_name;

  const MenuNav_Id = JSON.parse(localStorage.getItem("authUser"))
    ?.get_staff_data?.MenuNav_Id;

  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(
      getNavigationMenu([
        {
          menunavstructure_data: {
            MenuNav_Id,
          },
        },
      ])
    );
    dispatch(roleBasedNavigationMenu(LSRole));
  }, []);

  const { navigationMenu } = useSelector((state) => ({
    navigationMenu: state.NavigationMenu.navigationMenu,
  }));

  const { role } = useSelector((state) => ({
    role: state.NavigationMenu.role,
  }));

  const [apiMenu, setApiMenu] = useState([]);
  const [displayNavMenu, setDisplayNavMenu] = useState([]);

  useEffect(() => {
    if (isEmpty(navigationMenu)) {
      setApiMenu([]);
    } else {
      if (navigationMenu.status === 409) {
        setApiMenu([]);
      } else {
        setApiMenu(navigationMenu);
      }
    }
  }, [navigationMenu]);

  useEffect(() => {
    if (isEmpty(navigationMenu)) return;
    if (role === "localMenu") {
      setDisplayNavMenu(menuItems);
    } else {
      setDisplayNavMenu(apiMenu);
    }
  }, [role, apiMenu]);

  const history = useHistory();
  //state data
  const [isDashboard, setIsDashboard] = useState(false);
  const [isApps, setIsApps] = useState(false);
  const [isAuth, setIsAuth] = useState(false);
  const [isPages, setIsPages] = useState(false);
  const [isBaseUi, setIsBaseUi] = useState(false);
  const [isAdvanceUi, setIsAdvanceUi] = useState(false);
  const [isForms, setIsForms] = useState(false);
  const [isTables, setIsTables] = useState(false);
  const [isCharts, setIsCharts] = useState(false);
  const [isIcons, setIsIcons] = useState(false);
  const [isMaps, setIsMaps] = useState(false);
  const [isMultiLevel, setIsMultiLevel] = useState(false);

  // Apps
  const [isEmail, setEmail] = useState(false);
  const [isSubEmail, setSubEmail] = useState(false);
  const [isEcommerce, setIsEcommerce] = useState(false);
  const [isProjects, setIsProjects] = useState(false);
  const [isTasks, setIsTasks] = useState(false);
  const [isCRM, setIsCRM] = useState(false);
  const [isCrypto, setIsCrypto] = useState(false);
  const [isInvoices, setIsInvoices] = useState(false);
  const [isSupportTickets, setIsSupportTickets] = useState(false);
  const [isNFTMarketplace, setIsNFTMarketplace] = useState(false);

  // Authentication
  const [isSignIn, setIsSignIn] = useState(false);
  const [isSignUp, setIsSignUp] = useState(false);
  const [isPasswordReset, setIsPasswordReset] = useState(false);
  const [isPasswordCreate, setIsPasswordCreate] = useState(false);
  const [isLockScreen, setIsLockScreen] = useState(false);
  const [isLogout, setIsLogout] = useState(false);
  const [isSuccessMessage, setIsSuccessMessage] = useState(false);
  const [isVerification, setIsVerification] = useState(false);
  const [isError, setIsError] = useState(false);

  // Pages
  const [isProfile, setIsProfile] = useState(false);
  const [isLanding, setIsLanding] = useState(false);

  // Charts
  const [isApex, setIsApex] = useState(false);

  // Multi Level
  const [isLevel1, setIsLevel1] = useState(false);
  const [isLevel2, setIsLevel2] = useState(false);

  const [iscurrentState, setIscurrentState] = useState("");

  function updateIconSidebar(e) {
    if (e && e.target && e.target.getAttribute("subitems")) {
      const ul = document.getElementById("two-column-menu");
      const iconItems = ul.querySelectorAll(".nav-icon.active");
      let activeIconItems = [...iconItems];
      activeIconItems.forEach((item) => {
        item.classList.remove("active");
        var id = item.getAttribute("subitems");
        if (document.getElementById(id))
          document.getElementById(id).classList.remove("show");
      });
    }
  }

  useEffect(() => {
    document.body.classList.remove("twocolumn-panel");
    if (iscurrentState !== "Dashboard") {
      setIsDashboard(false);
    }
    if (iscurrentState !== "Apps") {
      setIsApps(false);
    }
    if (iscurrentState !== "Auth") {
      setIsAuth(false);
    }
    if (iscurrentState !== "Pages") {
      setIsPages(false);
    }
    if (iscurrentState !== "BaseUi") {
      setIsBaseUi(false);
    }
    if (iscurrentState !== "AdvanceUi") {
      setIsAdvanceUi(false);
    }
    if (iscurrentState !== "Forms") {
      setIsForms(false);
    }
    if (iscurrentState !== "Tables") {
      setIsTables(false);
    }
    if (iscurrentState !== "Charts") {
      setIsCharts(false);
    }
    if (iscurrentState !== "Icons") {
      setIsIcons(false);
    }
    if (iscurrentState !== "Maps") {
      setIsMaps(false);
    }
    if (iscurrentState !== "MuliLevel") {
      setIsMultiLevel(false);
    }
    if (iscurrentState === "Widgets") {
      history.push("/widgets");
      document.body.classList.add("twocolumn-panel");
    }
    if (iscurrentState !== "Landing") {
      setIsLanding(false);
    }
  }, [
    history,
    iscurrentState,
    isDashboard,
    isApps,
    isAuth,
    isPages,
    isBaseUi,
    isAdvanceUi,
    isForms,
    isTables,
    isCharts,
    isIcons,
    isMaps,
    isMultiLevel,
  ]);
  const InitialcompanyName = JSON.parse(localStorage.getItem("authUser"))
    ?.get_user_data?.Company_BusinessName?.toLowerCase()
    ?.replace(" ", "-")
    ?.replace(" ", "-")
    ?.replace(" ", "-");
  const [companyName, setCompanyName] = useState(InitialcompanyName);
  useEffect(() => {
    setCompanyName(InitialcompanyName);
  }, [InitialcompanyName]);

  const menuItems = [
    {
      label: "Menu",
      isHeader: true,
    },
    {
      // Task 24509 - top level and above the fold on purpose. This is the one
      // screen an engineer opens on a phone, and burying it under a group would
      // put it two taps away for the people who need it most.
      id: "MyDay",
      label: "My Day",
      icon: "las la-truck-moving",
      link: "/my-day",
    },
    {
      // Change #100670 - the vehicles assigned to me, next to My Day.
      id: "MyVehicles",
      label: "My Vehicles",
      icon: "ri-truck-line",
      link: "/my-vehicles",
    },
    {
      id: "CrmIt",
      label: "CrmIT",
      icon: "las la-crown",
      link: "/#",
      stateVariables: "Dashboard",
      click: function (e) {
        e.preventDefault();
        setIsDashboard(!isDashboard);
        setIscurrentState("Dashboard");
        updateIconSidebar(e);
      },
      subItems: [
        {
          id: "CrmItDashboard",
          label: "CrmIT Dashboard",
          icon: "las la-crown",
          link: "/dashboard",
          isChildItem: false,
        },
        {
          id: "PlatformMrr",
          label: "Platform MRR",
          icon: "las la-chart-line",
          link: "/platform-mrr",
          isChildItem: false,
        },
        {
          id: "RecentlyViewed",
          label: "Recently Viewed",
          icon: "las la-history",
          link: "/recently-viewed",
          isChildItem: false,
        },
        {
          id: "mailbox2",
          label: "Email",
          link: "/#",
          parentId: "CrmIt",
          isChildItem: true,
          childItems: [
            {
              id: 1,
              label: "Mailbox",
              link: "/crmit-email-inbox/",
              parentId: "CrmIt",
            },
          ],
        },
        {
          id: "invoices",
          label: "Invoices",
          link: "/#",
          isChildItem: true,
          parentId: "invoices",
          childItems: [
            { id: 1, label: "List View", link: "/crmit-invoices-list" },
            { id: 2, label: "Details", link: "/crmit-invoices-details/1" },
            { id: 3, label: "Create Invoice", link: "/crmit-invoices-create" },
            {
              id: 6,
              label: "Invoice item list",
              link: "/invoice-item-list",
            },
            { id: 4, label: "VAT Period Export", link: "/vat-period-export" },
            {
              id: 5,
              label: "Year End Export",
              link: "/year-end-period-export",
            },
            {
              id: 7,
              label: "Invoice Draft",
              link: "#",
              parentId: "invoiceDraft",
              isChildItem: true,
              childItems: [
                {
                  id: 1,
                  label: "Invoice Draft List",
                  link: "/invoices-draft-list",
                },
                // {
                //   id: 2,
                //   label: "Create Invoice Draft",
                //   link: "/create-invoice-draft",
                // },
                // {
                //   id: 3,
                //   label: "Search Invoice Draft",
                //   link: "/invoice-draft-search",
                // },
              ],
            },
          ],
        },
        {
          id: "proformaInvoices",
          label: "Proforma Invoices",
          link: "/#",
          isChildItem: true,
          parentId: "proformaInvoices",
          childItems: [
            { id: 1, label: "List View", link: "/proforma-invoices-list" },

            {
              id: 2,
              label: "Create Proforma Invoice",
              link: "/proforma-invoices-create",
            },
          ],
        },
        {
          id: "salesOrders",
          label: "Sales Orders",
          link: "/#",
          isChildItem: true,
          parentId: "salesOrders",
          childItems: [
            { id: 1, label: "Sales Order List", link: "/sales-order-list" },
            { id: 3, label: "Create Sales Order", link: "/sales-order-create" },
            {
              id: 3,
              label: "Sales Order Items List",
              link: "/sales-order-item-list",
            },
            {
              id: 4,
              label: "Reserved Stock List",
              link: "/reserved-stock-list",
            },
          ],
        },
        {
          id: "jobs",
          label: "Jobs",
          link: "/#",
          isChildItem: true,
          parentId: "jobs",
          childItems: [
            { id: 1, label: "Jobs List", link: "/apps-crm-jobs-list" },
            {
              id: 2,
              label: "Uninvoiced Jobs List",
              link: "/uninvoiced-jobs-list",
            },
            // Change #100386 - open jobs not updated in X days.
            { id: 3, label: "Stale Jobs", link: "/job/list/stale" },
          ],
        },

        {
          id: "Loyalty",
          label: "Loyalty",
          link: "/Loyalty",
          isChildItem: true,
          parentId: "Loyalty",
          childItems: [
            { id: 4, label: "Loyalty Dashboard", link: "/Loyalty-dashboard" },
            { id: 5, label: "Loyalty Terminal", link: "/Loyalty-terminal" },
            { id: 1, label: "Loyalty Transactions", link: "/Loyalty" },
            { id: 2, label: "Loyalty Balances", link: "/Loyalty-balances" },
            { id: 3, label: "Loyalty Vouchers", link: "/Loyalty-vouchers" },
            { id: 6, label: "Loyalty Portals", link: "/loyalty-portals" },
          ],
        },
        {
          id: "GiftVoucher",
          label: "Gift Vouchers",
          link: "/gift-voucher",
          isChildItem: false,
        },
        {
          id: "Faq",
          label: "FAQ",
          link: "/faqs-crm-it",
          isChildItem: false,
        },
        {
          id: "bank",
          label: "Bank",
          link: "/#",
          isChildItem: true,
          parentId: "bank",
          childItems: [
            { id: 1, label: "Bank List", link: "/bank-list" },
            {
              id: 2,
              label: "Transactions List",
              link: "/all-bank-transactions",
            },
            {
              id: 3,
              label: "Liability List",
              link: "/liability-list",
            },
            {
              id: 4,
              label: "Provider List",
              link: "/provider-list",
            },
          ],
        },
        {
          //CompanyRecentActivityList
          id: "CompanyRecentActivityList",
          label: "My Recent Activity List",
          link: "/my-recent-activity-list",
          parentId: "CrmIt",
        },
        {
          //HMRC
          id: "HMRC",
          label: "HMRC",
          link: "/hmrc",
          parentId: "CrmIt",
        },
      ],
    },
    {
      id: "Staff",
      label: "Staff",
      link: "/#",
      isChildItem: true,
      parentId: "Staff",
      icon: "fa-solid fa-users",
      subItems: [
        { id: 1, label: "Staff List", link: "/staff-list" },
        { id: 2, label: "Staff Income List", link: "/staff-income-list" },

        {
          id: 3,
          label: "Create Staff Income",
          link: "/create-edit-staff-income",
        },
        {
          id: 4,
          label: `${isBrandingActive ? "CrmIt " : ""}Calendar`,
          link: "/calendar-crm-it",
        },
        { id: 5, label: "Leave Requests List", link: "/leave-requests-list" },
        { id: 6, label: "Leave Allowance List", link: "/leave-allowance-list" },
        { id: 7, label: "Staff Holiday Record", link: "/staff-holiday-record" },
        { id: 8, label: "Staff Leave Overview", link: "/staff-leave-overview" },
        {
          id: 9,
          label: "Staff Leave Decision List",
          link: "/staff-leave-decision-list",
        },
        {
          id: 9,
          label: "Staff Directory",
          link: "/staff-directory",
        },
        {
          id: 10,
          label: "Staff Skill Set List",
          link: "/staff-skill-set-list",
        },
        // Change #100459
        {
          id: 16,
          label: "Skill Points",
          link: "/staff-skill-points",
        },
        {
          id: 11,
          label: "Staff Planner",
          link: "/staff-planner",
        },
        // Change #100130
        {
          id: 15,
          label: "Staff Attendance",
          link: "/staff-attendance",
        },
        {
          id: 12,
          label: "Payroll",
          link: "/payroll",
        },
        {
          id: 13,
          label: "Qualifications & Certifications",
          link: "/staff-qualifications-certifications",
        },
        {
          id: 14,
          label: "Qualification Catalog",
          link: "/credential-catalog",
        },
      ],
    },
    {
      id: "Assets",
      label: "Assets",
      link: "/#",
      parentId: "CrmIt",
      isChildItem: true,
      icon: "fa-solid fa-box-archive",
      subItems: [
        { id: 1, label: "Asset List", link: "/asset-list" },
        { id: 2, label: "Asset Settings", link: "/settings/1/40" },
      ],
    },
    // Knowledgebase (Task 24574) — the company's own documentation area.
    {
      id: "knowledgeBase",
      label: "Knowledgebase",
      link: "/#",
      parentId: "CrmIt",
      isChildItem: true,
      icon: "fa-solid fa-book-open",
      subItems: [
        { id: 1, label: "Browse", link: "/knowledge-base" },
        { id: 2, label: "New Article", link: "/knowledge-base/article/new/edit" },
        { id: 3, label: "Knowledgebase Settings", link: "/knowledge-base/admin" },
      ],
    },
    ...(showWhatsApp
      ? [
          {
            id: "whatsapp",
            label: "WhatsApp",
            link: "/messaging-service",
            parentId: "CrmIt",
            isChildItem: true,
            icon: "ri-whatsapp-line",
          },
        ]
      : []),
    {
      id: "tasks",
      label: "Tasks",
      link: "/#",
      parentId: "CrmIt",
      isChildItem: true,
      icon: "fa-solid fa-list-check",
      subItems: [
        {
          id: 1,
          label: "Weekly Tasks",
          link: "/weekly-tasks",
          parentId: "tasks",
        },
        {
          id: 3,
          label: "Weekly Tasks Kanban",
          link: "/weekly-tasks-kanban",
          parentId: "tasks",
        },
        {
          id: 4,
          label: "Status Tasks Kanban",
          link: "/status-tasks-kanban",
          parentId: "tasks",
        },
        {
          id: 2,
          label: "Tasks List",
          link: "/tasks",
          parentId: "tasks",
        },
      ],
    },
    // Task 24759 - the whole hospitality group is one module. CRM_FOOD_RESERVATION
    // covers table reservations AND pre-order events (see SYSTEM_MODULE_CODES).
    ...(showFoodReservation
      ? [
            {
              id: "Events&Pre-Order",
              label: "Events & Pre-Order",
              link: "/#",
              isChildItem: true,
              parentId: "Events&Pre-Order",
              icon: "fa-regular fa-calendar-check",
              subItems: [
                {
                  id: 1,
                  label: "Event Pre-Order",
                  link: "/event-pre-order",
                },
                {
                  id: 2,
                  label: "Event Pre-Order Menu",
                  link: "/event-pre-order-menu",
                },
                {
                  id: "event menu2",
                  label: "Event Food Menu V2",
                  link: "/EventMenuV2",
                },
        
                {
                  id: 3,
                  label: "Event Pre-Order Weekly",
                  link: "/event-pre-order-weekly",
                },
        
                {
                  id: "bookAtable",
                  parent: "bookAtable",
                  label: "Book A Table",
                  link: "#",
                  isChildItem: true,
                  childItems: [
                    {
                      id: 111,
                      label: "Book A Table Front End",
                      link: "/widget/restaurant-reservation/test12345",
                    },
                    {
                      id: 112,
                      label: "Reservation Diary",
                      link: "/reservation-diary/67/tableview",
                    },
                    {
                      id: 113,
                      label: "Payment Request List",
                      link: "/payment-request-list",
                    },
                  ],
                },
                {
                  id: 5,
                  label: "Guest Payment List",
                  link: "/guest-payment-list",
                },
                {
                  id: 6,
                  label: "Pre Order Group List",
                  link: "/event-pre-order-group-list",
                },
                {
                  id: 7,
                  label: "Shift Report Dashboard",
                  link: "/food-pre-order-shift-report-dashboard",
                },
                {
                  id: 9,
                  label: "On Boarding",
                  link: "/onboarding/table-reservation", // can be added tab and options later /:tab/:option
                },
              ],
            },
        ]
      : []),
    {
      id: "utilities",
      label: "Utilities",
      link: "/#",
      isChildItem: true,
      parentId: "utilities",
      icon: "fa-solid fa-gear",
      subItems: [
        { id: 1, label: "Appointment List", link: "/appointment-list" },
        {
          id: 10,
          label: "Time Entries",
          link: "#",
          parentId: "timeEntries",
          isChildItem: true,
          childItems: [
            { id: 1, label: "Time Entries List", link: "/time-entries" },
            {
              id: 2,
              label: "Time Entries Summary",
              link: "/time-entries-summary",
            },
            {
              id: 3,
              label: "Time Entries add in bulk",
              link: "/time-entries-add-in-bulk",
            },
          ],
        },
        {
          id: 7,
          label: "Product Custom Price",
          link: "/product-custom-price-list",
        },
        {
          id: 8,
          label: "Product",
          link: "/product-list",
          parentId: "product",
          isChildItem: true,
          childItems: [
            {
              id: 1,
              label: "Product List",
              link: "/product-list",
            },
            {
              id: 2,
              label: "Stock Location List",
              link: "/stock-location-list",
            },
            {
              id: 2,
              label: "Stock Transaction List",
              link: "/stock-transaction-list",
            },
          ],
        },
        {
          id: 9,
          label: "Reports",
          link: "/#",
          parentId: "reports",
          isChildItem: true,
          childItems: [
            {
              id: 1,
              label: "Business Overview",
              link: "/business-overview",
              parentId: "reports",
            },
            // Task 24742 - sits next to Business Overview because they are the
            // two halves of the same question: how is it trading, and where is
            // the money.
            {
              id: 12,
              label: "Finance Overview",
              link: "/finance-overview",
              parentId: "reports",
            },
            // Change #100064 - what the dunning engine would do right now.
            {
              id: 13,
              label: "Dunning Preview",
              link: "/dunning-preview",
              parentId: "reports",
            },
            {
              id: 11,
              label: "Recurring Revenue",
              link: "/recurring-revenue",
              parentId: "reports",
            },
            {
              id: 2,
              label: "Customer Product List",
              link: "/reports/customer-product-list",
              parentId: "reports",
            },
            {
              id: 3,
              label: "Job Time Entry",
              link: "/reports/job-time-entry",
              parentId: "reports",
            },
          ],
        },
        {
          id: 10,
          label: "Data Import",
          link: "/data-import",
        },
        {
          id: 11,
          label: "Product BOM",
          link: "/product-bom",
        },
        {
          id: 12,
          label: "Email Marketing",
          link: "/email-marketing",
        },
        {
          id: 14,
          label: "Dashboard v2",
          link: "/dashboard-upgrade-v2",
        },
        {
          id: 15,
          label: "Reviews Centre",
          link: "/reviews-centre",
        },
        {
          id: 13,
          label: "Assets",
          link: "/#",
          parentId: "assets",
          isChildItem: true,
          childItems: [
            { id: 1, label: "Asset List", link: "/asset-list" },
            { id: 2, label: "Asset Settings", link: "/settings/1/40" },
          ],
        },
        // Knowledgebase (Task 24574)
        {
          id: 16,
          label: "Knowledgebase",
          link: "/knowledge-base",
        },
      ],
    },
    {
      id: "customerList",
      label: "Customers",
      link: "/#",
      icon: "fa-solid fa-user-tie",
      isChildItem: true,
      parentId: "customerList",
      subItems: [
        { id: 1, label: "Customer List", link: "/customer-list" },
        // Change #100518 - every contact person in the company.
        { id: "contactPersonList", label: "Contact List", link: "/contact-person-list" },
        {
          id: 2,
          label: "Customer Balance",
          link: "/customer-balance",
        },
        {
          id: "3",
          label: "Contracts",
          link: "/#",
          parentId: "contract",
          isChildItem: true,
          childItems: [
            {
              id: 1,
              label: "Contract List",
              link: "/contract-list/",
              parentId: "contract",
            },
            {
              id: 2,
              label: "Contract Item List",
              link: "/contract-items-list",
              parentId: "contract",
            },
            {
              id: 3,
              label: "Contract Item Usage search",
              link: "/contract-items-usage-search",
              parentId: "contract",
            },
            {
              id: 4,
              label: "Contract Portfolio",
              link: "/contract-portfolio",
              parentId: "contract",
            },
          ],
        },
        {
          id: 4,
          label: "Dunning",
          link: "/#",
          parentId: "contract",
          isChildItem: true,
          childItems: [
            {
              id: 1,
              label: "Dunning List",
              link: "/dunning-list",
              parentId: "contract",
            },
            {
              id: 2,
              label: "Lock List",
              link: "/dunning-lock-list",
              parentId: "contract",
            },
          ],
        },
        {
          id: 12,
          label: "Purchase",
          link: "/#",
          parentId: "purchase",
          isChildItem: true,
          childItems: [
            {
              id: 5,
              label: "Purchase List",
              link: "/purchase-List",
            },
            {
              id: 6,
              label: "Purchase Item List",
              link: "/purchase-Item-List",
            },
            {
              id: 7,
              label: "Create Purchase",
              link: "/create-purchase",
            },
            {
              id: 8,
              label: "Purchase Order List",
              link: "/purchase-order-list",
            },
            {
              id: 9,
              label: "Purchase Draft List",
              link: "/purchase-draft-list",
            },
            {
              id: 9,
              label: "Create Purchase Draft",
              link: "/create-purchase-draft",
            },
          ],
        },

        {
          id: 7,
          label: "Opportunities List",
          link: "/opportunities-list",
          parentId: "contract",
          isChildItem: true,
          childItems: [
            {
              id: 1,
              label: "Opportunities List",
              link: "/opportunities-list",
            },
            {
              id: 2,
              label: "Opportunities Reports",
              link: "/opportunity-reports",
            },
          ],
        },
        {
          id: 9,
          label: "Suppliers",
          link: "/#",
          parentId: "suppliers",
          isChildItem: true,
          childItems: [
            {
              id: 1,
              label: "Suppliers List",
              link: "/suppliers-list",
              parentId: "contract",
            },
            {
              id: 2,
              label: "Suppliers Banalnce List",
              link: "/supplier-balance-list",
              parentId: "contract",
            },
            {
              // Task 24319
              id: 3,
              label: "Purchase Invoice Links",
              link: "/purchase-invoice-links",
              parentId: "contract",
            },
          ],
        },
        {
          id: 10,
          label: "Quotes",
          link: "/#",
          parentId: "suppliers",
          isChildItem: true,
          childItems: [
            {
              id: 1,
              label: "Quotes List",
              link: "/quote-list",
              parentId: "Quotes",
            },
          ],
        },
        {
          id: 10,
          label: "Person",
          link: "/#",
          parentId: "Person",
          isChildItem: true,
          childItems: [
            {
              id: 1,
              label: "Person List",
              link: "/person-list",
              parentId: "Person",
            },
          ],
        },
      ],
    },

    {
      id: "BackEnd",
      label: "Back End",
      icon: "bx bxs-dashboard",
      link: "/#",
      stateVariables: isDashboard,
      click: function (e) {
        e.preventDefault();
        setIsDashboard(!isDashboard);
        setIscurrentState("Backend");
        updateIconSidebar(e);
      },
      subItems: [
        {
          id: "CompanyUsageList",
          label: "Company Usage List",
          link: "/company-usage-list",
          parentId: "BackEnd",
        },
        {
          id: "CompanyReportList",
          label: "Company Report List",
          link: "/company-report-list",
          parentId: "BackEnd",
        },
        {
          id: "userReportList",
          label: "User Report List",
          link: "/user-report-list",
          parentId: "BackEnd",
        },
        {
          id: "userActivityList",
          label: "User Activity List",
          link: "/user-activity-list",
          parentId: "BackEnd",
        },
        {
          id: "partnersList",
          label: "Partners List",
          link: "/partners-list",
          parentId: "BackEnd",
        },
        {
          id: "Exports",
          label: "Exports",
          link: "/export",
          parentId: "BackEnd",
        },
        {
          id: "master-error-log-list",
          label: "Master Error Log List",
          link: "/master-error-log-list",
          parentId: "BackEnd",
        },
        {
          id: "slow-query-monitor",
          label: "Slow Query Monitor",
          link: "/slow-query-monitor",
          parentId: "BackEnd",
        },
        {
          id: "system-wallets",
          label: "System Wallets",
          link: "/system-wallets",
          parentId: "BackEnd",
        },
      ],
    },
    {
      id: "prototyping",
      label: "Prototyping",
      icon: "fa-solid fa-robot",
      link: "/#",
      stateVariables: isDashboard,
      click: function (e) {
        e.preventDefault();
        setIsDashboard(!isDashboard);
        setIscurrentState("Backend");
        updateIconSidebar(e);
      },
      subItems: [
        {
          id: "ecommerce",
          label: "Ecommerce",
          link: `/ecommercestore/test12345/shopping`,
        },
        {
          id: "gps",
          label: "GPS",
          link: "/gps",
        },
        {
          id: "ClosestToCustomer",
          label: "Closest To Customer",
          link: "/closest-to-customer",
        },
        {
          id: "dailyPlanner",
          label: "Daily Planner",
          link: "/daily-planner",
        },
        {
          id: "dailyPlanner2",
          label: "Daily Planner2",
          link: "/daily-planner2/vertical/date=today",
        },
        {
          id: "dailyPlannerTv",
          label: "Daily Planner Tv",
          link: "/daily-planner/tv",
        },
        {
          id: "voice-to-text",
          label: "Voice To Text",
          link: "/voice-to-text",
        },
        { id: 1, label: "Prototype", link: "/prototype" },
        { id: 1, label: "MRP ORDER", link: "/mrp-order/:id" },
        { id: 9, label: "Settings", link: "/settings" },
        { id: 6, label: "Profit & Loss", link: "/profit-and-loss" },
        {
          id: 6,
          label: "Company Earnings Report",
          link: "/company-earnings-report",
        },
        { id: 7, label: "xls prototyping", link: "/xls-prototyping" },
        {
          id: 12,
          label: "Contact Lookup",
          link: "/contact-person-lookup-list",
        },
        {
          id: 8,
          label: "Staff List",
          link: "/staff-list",
        },
        {
          id: 9,
          label: "Checklist List",
          link: "/checklist-list",
        },
        {
          id: "checklist-builder",
          label: "Checklist Builder",
          link: "/checklist-templates",
        },
        {
          id: 10,
          label: "Data Import Center",
          link: "/data-import-center",
        },
        {
          id: "change-tracking",
          label: "Change Tracking",
          link: "/change-tracking",
        },
        {
          id: 11,
          label: "Prototype Jobs List",
          link: "/prototype-job-list",
        },
        {
          id: 12,
          label: "My Dashboard",
          link: "/my-dashboard",
        },
        {
          id: 13,
          label: `Chat ${isBrandingActive && "CRMit"}`,
          link: "/chat-crmit",
        },
        {
          id: 14,
          label: "Voice To Text",
          link: "/voice-to-text",
        },
        {
          id: 15,
          label: "Social Media Management",
          link: "/social-media-management",
        },
        {
          id: 16,
          label: "Manage your Marketing Preference",
          link: "/manage-your-marketing-preference/:token:/:email",
        },
        {
          id: 17,
          label: "HMRC Hub",
          link: "/hmrc-hub",
        },
        {
          id: 18,
          label: "Loyalty Login",
          link: "/loyalty-login",
        },
        {
          id: 19,
          label: "Marketing",
          link: "/marketing",
        },
        {
          id: 20,
          label: "Leads",
          link: "/leads",
        },
        {
          id: 21,
          label: "POS Settings",
          link: "/possystem/settings",
        },
        {
          id: 22,
          label: "POS Restaurant",
          link: "/possystem/restaurant",
        },
        {
          id: 23,
          label: "POS Cafe",
          link: "/possystem/1",
        },
        {
          id: 24,
          label: "Automation",
          link: "/automation",
        },
        {
          id: 25,
          label: "Forms",
          link: "/form-list",
        },
        {
          id: 26,
          label: "Video Call",
          link: "/video-call/room1",
        },
        {
          id: 27,
          label: "PDF Designer",
          link: "/pdf-designer",
        },
        {
          id: 28,
          label: "E-Sign",
          link: "/e-sign-list",
        },
        {
          id: 29,
          label: "Ecommerce Stores",
          link: "/ecommerce-store-list",
        },
      ],
    },
    {
      id: "vehicle",
      label: "Vehicle",
      icon: "fa-solid fa-car",
      subItems: [
        ...(showCustomerVehicle
          ? [
              {
                id: "vehicleList",
                label: "Vehicle List",
                link: "/vehicle-list",
                parentId: "vehicle",
              },
            ]
          : []),
        {
          id: "companyVehicleList",
          label: "Company Fleet",
          link: "/companyvehicle-list",
          parentId: "vehicle",
        },
      ],
    },
  ];
  return <React.Fragment>{displayNavMenu}</React.Fragment>;
};
export default Navdata;
